import { customFieldName, PageCustomField } from '~/utils/custom-field-utils'

import { cn } from '~/utils/cn'

import { CustomFieldInput } from './CustomFieldInput'

type Props = {
  fields: PageCustomField[]
  className?: string
  // Formik path that holds the answers. An attendee block nests them.
  path?: string
}

export const CustomFieldsSection = ({ fields, className, path }: Props) => {
  if (!fields.length) {
    return null
  }

  return (
    <div className={cn('grid grid-cols-1 gap-5 md:col-span-2', className)}>
      {fields.map(field => (
        <CustomFieldInput
          key={field.id}
          name={customFieldName(field, path)}
          label={field.label}
          type={field.type}
          options={field.options}
          optional={!field.required}
        />
      ))}
    </div>
  )
}
